module.exports = __webpack_public_path__ + "fonts/source-sans-pro-v13-latin-italic.90e0cd5f.eot";